import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import PractitionersPage from '@/pages/PractitionersPage';
import PractitionerStaffManagement from '@/pages/PractitionerStaffManagement';
import RoleManagement from '@/pages/RoleManagement';
import UserManagement from '@/pages/UserManagement';
import AdminManagement from '@/pages/AdminManagement';
import { useSearchParams } from 'react-router-dom';

const StaffPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const defaultTab = searchParams.get('tab') || 'practitioners';

  const handleTabChange = (value: string) => {
    setSearchParams({ tab: value }, { replace: true });
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">Staff</h1>
        <p className="text-sm text-slate-500 mt-1">Manage practitioners, staff roles, users, and administrators.</p>
      </div>

      <Tabs defaultValue={defaultTab} onValueChange={handleTabChange} className="w-full">
        <TabsList className="border-b border-slate-200 bg-transparent h-auto p-0 space-x-0 w-full justify-start rounded-none">
          <TabsTrigger
            value="practitioners"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Practitioners
          </TabsTrigger>
          <TabsTrigger
            value="practitioner-staff"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Practitioner Staff
          </TabsTrigger>
          <TabsTrigger
            value="roles"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Roles
          </TabsTrigger>
          <TabsTrigger
            value="users"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Users
          </TabsTrigger>
          <TabsTrigger
            value="admins"
            className="rounded-none border-b-2 border-transparent px-4 py-2.5 text-sm font-medium text-slate-500 hover:text-slate-700 data-[state=active]:border-brand-teal data-[state=active]:text-slate-900 data-[state=active]:bg-transparent data-[state=active]:shadow-none transition-colors"
          >
            Admins
          </TabsTrigger>
        </TabsList>

        <div className="mt-6">
          <TabsContent value="practitioners" className="m-0">
            <PractitionersPage />
          </TabsContent>
          <TabsContent value="practitioner-staff" className="m-0">
            <PractitionerStaffManagement />
          </TabsContent>
          <TabsContent value="roles" className="m-0">
            <RoleManagement />
          </TabsContent>
          <TabsContent value="users" className="m-0">
            <UserManagement />
          </TabsContent>
          <TabsContent value="admins" className="m-0">
            <AdminManagement />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
};

export default StaffPage;
